import React from "react";
import { Field, Input, SectionTitle } from "./_shared";
import { X, Plus } from "lucide-react";

export default function BrandsEditor({ value, onChange }) {
  const setBrand = (i, v) => {
    const next = [...value]; next[i] = v; onChange(next);
  };
  const addBrand = () => onChange([...value, "Nueva marca"]);
  const removeBrand = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      <SectionTitle
        title="Marcas / Clientes"
        subtitle="Se muestran en el carrusel infinito"
        right={
          <button onClick={addBrand} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white text-black text-sm font-medium hover:bg-neutral-100 transition-colors">
            <Plus className="w-4 h-4" /> Añadir marca
          </button>
        }
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {value.map((b, i) => (
          <div key={i} className="flex gap-2">
            <Input value={b} onChange={(e) => setBrand(i, e.target.value)} />
            <button onClick={() => removeBrand(i)} className="w-10 h-10 rounded-lg border border-white/10 hover:border-red-500/40 text-white/50 hover:text-red-400 flex items-center justify-center transition-colors">
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
